import { useQuery } from '@tanstack/react-query';
import { popupApiAdapter } from '../adapters/PopupApiAdapter';
import type { PopupCountFilters } from '../models/Popup';

interface UsePopupCountByStatusOptions {
  enabled?: boolean;
}

export function usePopupCountByStatus(filters?: PopupCountFilters, options?: UsePopupCountByStatusOptions) {
  const queryKey = ['popups', 'count-by-status', filters];
  const enabled = options?.enabled ?? true;

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey,
    queryFn: () => popupApiAdapter.getCountByStatus(filters),
    staleTime: 5 * 60 * 1000,
    enabled,
  });

  return {
    counts: data ?? { active: 0, archived: 0 },
    isLoading,
    isFetching,
    error,
    refetch,
  };
}
